import * as React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { formHelperTextPropTypes, } from './FormHelperText.types';
import { StyledFormHelperText, StyledErrorIcon, StyledErrorIconPath, } from './FormHelperText.styles';
const ErrorIcon = () => {
    const locale = useLocale();
    return (React.createElement(StyledErrorIcon, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, locale.formHelperText.errorIconTitle),
        React.createElement(StyledErrorIconPath, { d: "M21.5,20.5 L1.5,20.5 L11.5,2.5 L21.5,20.5 Z M11.5,16 L11.5,18 M11.5,8 L11.5,14" })));
};
export const FormHelperText = React.forwardRef(({ variant = 'hint', disabled = false, children, ...restProps }, ref) => {
    const showErrorIcon = variant === 'invalid';
    return (React.createElement(StyledFormHelperText, { variant: variant, disabled: disabled, ref: ref, ...pickComponentCommonProps(restProps), outerSpacing: useSpacing(restProps) },
        showErrorIcon && React.createElement(ErrorIcon, null),
        children));
});
FormHelperText.displayName = 'FormHelperText';
FormHelperText.propTypes = formHelperTextPropTypes;
//# sourceMappingURL=FormHelperText.js.map